import { demoAccount } from "./demo-account";

export const accountQuery = {
  read(_: any) {
    return demoAccount;
  },
};

export const tradingAccountUsersQuery = {
  read(_: any) {
    return [
      {
        id: "337c139c-ba90-48d2-af8a-0c54609679af",
        email: "tracexadministrator@powerledger.io",
        firstName: "Marie",
        lastName: "Stergiou",
        tradingAccountUserType: "ADMIN",
        position: null,
        status: "ACTIVE",
        isAccountOwner: true,
        __typename: "TradingAccountUser",
      },
    ];
  },
};
